<template>
  <b-container fluid class="p-0">
    <b-row class="p-3 mt-5">
      <b-col md="4" offset-md="3">
        <b-row>
          <b-col cols="12">
            <b-alert show variant="info">
              Para prosseguir com seu cadastro por favor insira seu CPF
            </b-alert>
          </b-col>
        </b-row>
        <div>
          <b-card :header="header" header-tag="header">
            <b-card-text>
              <b-row>
                <b-col
                  cols="12"
                  v-if="this.token == null || this.token.length == 0"
                >
                  <b-form-group label="CPF">
                    <b-form-input
                      v-model="user.cpf"
                      v-mask="'###.###.###-##'"
                      v-on:keyup="validarCPF()"
                      @keydown.enter.stop.prevent
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { sharedService } from "../../services";

export default {
  data() {
    return {
      senha_confirmar: "",
      email_confirmar: "",
      header: "Registrar CPF",
      dica: "",
      dicaTexto: "",
      cpf_isvalido: false,
      googleObj: {},
      successAuth: false,
    };
  },
  components: {},
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    token: function () {
      return this.$store.getters.getToken;
    },
    googleToken: function () {
      return this.$store.getters.getGoogleObj;
    },
  },
  beforeMount() {
    if (this.$gAuth.isAuthorized == false) {
      // eslint-disable-next-line no-console
      console.error("não tem permissão pra logar");
    } else {
      // eslint-disable-next-line no-console
      console.info("tem permissão pra logar");
    }
    if (this.user.id == null || this.user.id == 0) {
      (this.dica = "info"),
        (this.dicaTexto = "Para começar, informe o seu CPF");
    } else {
      (this.dica = ""), (this.dicaTexto = "");
    }
  },
  methods: {
    async loginGoogle() {
      let self = this;
      const googleUser = await this.$gAuth.signIn();
      this.googleObj = googleUser.getBasicProfile();
      //this.successAuth = this.$gAuth.isAuthorized
      if (this.$gAuth.isAuthorized == true) {
        this.$store.dispatch("actGoogleObj", {
          googleId: this.googleObj.lS,
          nome: this.googleObj.Me,
          email: this.googleObj.Dt,
          foto: this.googleObj.gJ,
        });
        //self.user.nome = this.googleObj.Me;
        self.user.email = this.googleObj.Dt;
        self.user.token_google = this.googleObj.lS;
        self.logarToken();
      }
    },
    async logOutGoogle() {
      this.$gAuth.signOut();
      this.$store.dispatch("actGoogleObj", {});
    },

    irVagas() {
      this.$router.push({
        name: "vagas_encaminhadas",
      });
    },
    editarCurriculo() {
      if (this.user.id !== 0) {
        this.$router.push({
          name: "curriculo",
        });
      }
    },
    cadastrar: function (e) {
      e.preventDefault();
      if (this.user.senha !== this.senha_confirmar) {
        this.$swal({
          icon: "info",
          position: "top",
          title: "Confira os dados digitados",
          text: "Os campos [Senha] e [Confirmar Senha] devem ter o mesmo conteúdo",
          footer:
            "verifique o valor informado!! - para acessar seu curriculo no futuro será necessário saber a senha",
        });
      } else if (this.user.email != this.email_confirmar) {
        this.$swal({
          icon: "info",
          position: "top",
          title: "Confira os dados digitados",
          text: "Os campos [Email] e [Confirmar Email] devem ter o mesmo conteúdo",
          footer:
            "verifique o valor informado!! - para recuperar sua senha será necessário o seu email",
        });
      } else {
        this.$router.push({
          name: "curriculo",
        });
      }
    },
    recover() {
      let self = this;
      let loader = this.$loading.show();
      sharedService
        .createRecuperar(
          "Candidato/recuperarsenha",
          { cpf: this.user.cpf },
          this.$store.getters.getApiKey
        )
        .then(function (obj) {
          if (obj.status === 200) {
            self.$swal({
              icon: "info",
              position: "top",
              title: "Recuperar Senha",
              text: "Foi encaminhado para o seu email cadastrado um link para alterar a sua senha cadastrada.",
              footer:
                "verifique na sua caixa de entrada, caso não encontre, de uma olhadinha na caixa de SPAM!!!",
            });
          } else {
            self.$swal({
              icon: "error",
              position: "top",
              title: "Oops...",
              text: "Não foi possivel recuperar a sua senha!",
              footer:
                "Os dados fornecidos não permitem encaminhar um email para recuperar sua senha, por favor entre em contato",
            });
          }
          loader.hide();
        });
    },
    validarCPF(val) {
      let self = this;
      val = this.user.cpf;
      this.cpf_isvalido = false;
      if (val.length === 14) {
        let aux = 10;
        let somatoria = 0;
        for (var i = 0; i <= 8; i++) {
          somatoria =
            somatoria +
            val.replace(".", "").replace(".", "").replace("-", "")[i] * aux;
          aux = aux - 1;
        }

        let multiplicao = (somatoria * 10) % 11;
        if (multiplicao === 10 || multiplicao === 11) {
          multiplicao = 0;
        }

        if (
          val === "111.111.111-11" ||
          val === "222.222.222-22" ||
          val === "333.333.333-33" ||
          val === "444.444.444-44" ||
          val === "555.555.555-55" ||
          val === "666.666.666-66" ||
          val === "777.777.777-77" ||
          val === "888.888.888-88" ||
          val === "999.999.999-99"
        ) {
          self.dicaTexto = "CPF Inválido!";
          self.dica = "danger";
        } else if (
          multiplicao ===
          Number(val.replace(".", "").replace(".", "").replace("-", "")[9])
        ) {
          let aux2 = 11;
          let somatoria2 = 0;

          for (var j = 0; j <= 9; j++) {
            somatoria2 =
              somatoria2 +
              val.replace(".", "").replace(".", "").replace("-", "")[j] * aux2;
            aux2 = aux2 - 1;
          }

          let multiplicao2 = (somatoria2 * 10) % 11;
          if (multiplicao2 === 10 || multiplicao2 === 11) {
            multiplicao2 = 0;
          }
          if (
            multiplicao2 ===
            Number(val.replace(".", "").replace(".", "").replace("-", "")[10])
          ) {
            this.$store.dispatch("verificaCPF", val).then(function () {
              if (self.user.id == null || self.user.id == 0) {
                let googleObj = self.$store.getters.getGoogleObj;
                //self.user.nome = googleObj.nome;
                self.user.email = googleObj.email;
                self.user.token_google = googleObj.googleId;
                self.$router.push({
                  name: "curriculo",
                });
              } else {
                self.$swal({
                  icon: "error",
                  position: "top",
                  title: "Cpf já cadastrado",
                  html: "CPF já cadastrado na nossa base de dados, por favor insira outro CPF",
                  footer: "",
                });
                self.user.cpf = "";
              }
            });
          } else {
            self.dicaTexto = "CPF Inválido!";
            self.dica = "danger";
          }
        } else {
          self.dicaTexto = "CPF Inválido!";
          self.dica = "danger";
        }
      }
    },
  },
};
</script>

<style scoped>
.alert-info {
  color: #ffffff;
  background-color: #d94452;
  border-color: #d94452;
  border-bottom: 5px solid #eb5463;
}

.btn-success {
  background-color: #4cba9b;
  border-color: #4cba9b;
}

.btnGoogle {
  background: #fff;
  border: none;
  padding: 0.6rem 0.6rem;
  font-weight: bold;
  border-radius: 5px;
  -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}
</style>
